import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeFiveTitles from '../components/ThemeFiveTitles';

const ThemeFiveTnCScreen = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const createMarkup = data => {
    return { __html: data };
  };

  return (
    <div className="">
      <KuposHelmet />

      <HeroSection
        title={'Términos y condiciones'}
        height={'30vh'}
        description={'Home / Términos y condiciones'}
        heroImage={getIcons('tncBanner', operator)}
      />

      {operator.operator_name ==='jeldres' ?
      (<ThemeFiveTitles className="mb-4" smallHeading="Conoce" boldHeading="NUESTROS TÉRMINOS Y CONDICIONES" />) :null}

      <div className="new-container mb10 mt10">
        <div
          dangerouslySetInnerHTML={createMarkup(operator.terms ? operator.terms : '')}
          className="lh-1-3 font11 justify-text"
        />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFiveTnCScreen);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/ThemeFivePages/ThemeFiveTnCScreen.js